module.exports = __webpack_public_path__ + "static/media/settings.ab31c939.svg";